define('views/terms/terms_reroute',[
	'backbone',
	'views/_base/baseview',
	'text!views/terms/term_links.html',
], function(Backbone, BaseView, Template){
	'use strict';

	return BaseView.extend({
		className: 'profile-content',
		tagName  : 'div',
		isRender : false,
		needsAuth: false,
		template : _.template(Template),
		events   : {},

		initialize: function(options){
			options = options || {};

			this.options = options.options || {};

			this.site_version = pf.getContent('version.id');

			this.new_window = options.new_window;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function(){
			var that = this;

			this.$el.html(this.template());

			return this;
		},

		loadData: function(){

			this.openTermsView();

		},

		openTermsView: function(){

			switch(this.options.view){
				case 'approved_items':
					this.showApprovedItems();
					break;
				case 'fees':
					this.showFeesAgreement();
					break;
				case 'terms-of-service':
					this.showTermsOfService();
					break;
				case 'incentives':
					this.showIncentives();
					break;
				case 'cardholder-agreement':
					this.showCardholderAgreement();
					break;
				case 'accountholder-agreement':
					this.showAccountholderAgreement();
					break;
				case 'privacy-policy':
					this.showPrivacyPolicy();
					break;
				case 'prepaid-policy':
					this.showPrepaidPrivacy();
					break;
				default:
					break;
			}

		},

		loadPdfURL: function(link){

			if(link){

				var url = pf.getContent('global.url.pdf_root');

				if(url){

					var full_url = ((window.location.origin + window.location.pathname) + url) + link;

					if(full_url){

						window.location.href = ((window.location.origin + window.location.pathname) + url) + link;

					}
					
				}

			}
			
		},

		showFeesAgreement: function(){

			if(this.site_version == enums.siteVersion.bcbssc){
				var link = pf.getContent('terms.content.pdf.fees_bcbssc.name');
			} else if(this.site_version == enums.siteVersion.almyblue){
				var link = pf.getContent('terms.content.pdf.fees_almyblue.name');
			} else if(this.site_version == enums.siteVersion.rxsavings){
				var link = pf.getContent('terms.content.pdf.fees_rxsavings.name');
			} else if(this.site_version == enums.siteVersion.proteus){
				var link = pf.getContent('terms.content.pdf.fees_proteus.name');
			} else if(this.site_version == enums.siteVersion.alahealth) {
				var link = pf.getContent('terms.content.pdf.fees_alahealth.name');
			} else if(this.site_version == enums.siteVersion.bcbsal){
				var link = pf.getContent('terms.content.pdf.fees_bewell.name');
			} else if(this.site_version == enums.siteVersion.csnp){
				var link = pf.getContent('terms.content.pdf.fees_bcbssc.name');
			} else {
				var link = pf.getContent('terms.content.pdf.fees.name');
			}

			this.loadPdfURL(link);
		},

		showTermsOfService: function(){
			var link = pf.getContent('terms.content.pdf.terms_of_service.name');
			this.loadPdfURL(link);
		},

		showApprovedItems: function() {
			var link = pf.getContent('footer.content.approved_items.pdf');
			this.loadPdfURL(link);
		},

		showIncentives: function(){
			var link = pf.getContent('terms.content.pdf.incentives_terms_of_service.name');
			this.loadPdfURL(link);
		},

		showCardholderAgreement: function(){

			if(this.site_version == enums.siteVersion.rxsavings){
				var link = pf.getContent('terms.content.pdf.cardholder_agreement_rxsavings.name');
			} else if(this.site_version == enums.siteVersion.bcbssc){
				var link = pf.getContent('terms.content.pdf.cardholder_agreement_bluerewards.name');
			} else if(this.site_version == enums.siteVersion.csnp){
				var link = pf.getContent('terms.content.pdf.cardholder_agreement_csnp.name');
			} else if(this.site_version == enums.siteVersion.almyblue) {
				var link = pf.getContent('terms.content.pdf.cardholder_agreement_almyblue.name');
			} else if(this.site_version == enums.siteVersion.bcbsal){
				var link = pf.getContent('terms.content.pdf.cardholder_agreement_bewell.name');
			} else if (this.site_version == enums.siteVersion.proteus) {
				var link = pf.getContent('terms.content.pdf.cardholder_agreement_proteus.name'); 
			} else if (this.site_version == enums.siteVersion.alahealth) {
				var link = pf.getContent('terms.content.pdf.cardholder_agreement_alahealth.name'); 
			} else {
				var link = pf.getContent('terms.content.pdf.cardholder_agreement.name');
			}
			
			this.loadPdfURL(link);

		},

		showAccountholderAgreement: function(){
			var link = pf.getContent('terms.content.pdf.accountholder_agreement.name');
			this.loadPdfURL(link);
		},

		showPrivacyPolicy: function(){
			var link = pf.getContent('terms.content.pdf.privacy_policy.name');
			this.loadPdfURL(link);
		},

		showPrepaidPrivacy: function(){
			var link = pf.getContent('terms.content.pdf.prepaid_privacy.name');
			this.loadPdfURL(link);
		},

		close: function(){}
	});
});

